import BaseService from './base.service'

export class UserService extends BaseService {
  static resource = 'user'

  static updateUserSettings(userSettings) {
    return this.post('UpdateUserSettings', userSettings)
  }

  // The whole response: a password change ends the sessions signed before it, so the app has
  // to keep the token that comes back
  static update(entity) {
    return this.postForResponse('profile', entity)
  }

  static getCurrent() {
    return this.get('current')
  }
}

export class ItemService extends BaseService {
  static resource = 'items'
}

export class ProcessService extends BaseService {
  static resource = 'processes'
}
